/**
 * BabylonJS Global Shim
 * Exposes the global BABYLON object loaded from CDN as ES module exports.
 *
 * BabylonJS is loaded on demand (src/3d-lib/babylonjs/loadBabylon.ts), after this
 * module may already have been evaluated, so the exports are live bindings that
 * bindBabylonGlobals() fills in once window.BABYLON exists. Importers always see
 * the current value because ES module bindings are live.
 */

let BABYLON = {};

export { BABYLON as default };

export let Engine;
export let Scene;
export let ArcRotateCamera;
export let FreeCamera;
export let UniversalCamera;
export let HemisphericLight;
export let DirectionalLight;
export let PointLight;
export let SpotLight;
export let Vector3;
export let Vector2;
export let Color3;
export let Color4;
export let Space;
export let Axis;
export let Mesh;
export let MeshBuilder;
export let TransformNode;
export let AbstractMesh;
export let SceneLoader;
export let Animation;
export let AnimationGroup;
export let AnimationPropertiesOverride;
export let Bone;
export let Skeleton;
export let PBRMaterial;
export let StandardMaterial;
export let Texture;
export let CubeTexture;
export let MorphTarget;
export let Debug;
export let EnvironmentHelper;
export let Layer;
export let ActionManager;
export let ExecuteCodeAction;
export let Observable;
export let Observer;
export let PointerEventTypes;
export let PointerInfo;
export let KeyboardEventTypes;
export let KeyboardInfo;
export let Nullable;
export let AxesViewer;
export let IAnimationKey;
export let MorphTargetManager;
export let GLTF2;
export let GLTFFileLoader;

export function bindBabylonGlobals() {
    BABYLON = window.BABYLON || {};
    Engine = BABYLON.Engine;
    Scene = BABYLON.Scene;
    ArcRotateCamera = BABYLON.ArcRotateCamera;
    FreeCamera = BABYLON.FreeCamera;
    UniversalCamera = BABYLON.UniversalCamera;
    HemisphericLight = BABYLON.HemisphericLight;
    DirectionalLight = BABYLON.DirectionalLight;
    PointLight = BABYLON.PointLight;
    SpotLight = BABYLON.SpotLight;
    Vector3 = BABYLON.Vector3;
    Vector2 = BABYLON.Vector2;
    Color3 = BABYLON.Color3;
    Color4 = BABYLON.Color4;
    Space = BABYLON.Space;
    Axis = BABYLON.Axis;
    Mesh = BABYLON.Mesh;
    MeshBuilder = BABYLON.MeshBuilder;
    TransformNode = BABYLON.TransformNode;
    AbstractMesh = BABYLON.AbstractMesh;
    SceneLoader = BABYLON.SceneLoader;
    Animation = BABYLON.Animation;
    AnimationGroup = BABYLON.AnimationGroup;
    AnimationPropertiesOverride = BABYLON.AnimationPropertiesOverride;
    Bone = BABYLON.Bone;
    Skeleton = BABYLON.Skeleton;
    PBRMaterial = BABYLON.PBRMaterial;
    StandardMaterial = BABYLON.StandardMaterial;
    Texture = BABYLON.Texture;
    CubeTexture = BABYLON.CubeTexture;
    MorphTarget = BABYLON.MorphTarget;
    Debug = BABYLON.Debug;
    EnvironmentHelper = BABYLON.EnvironmentHelper;
    Layer = BABYLON.Layer;
    ActionManager = BABYLON.ActionManager;
    ExecuteCodeAction = BABYLON.ExecuteCodeAction;
    Observable = BABYLON.Observable;
    Observer = BABYLON.Observer;
    PointerEventTypes = BABYLON.PointerEventTypes;
    PointerInfo = BABYLON.PointerInfo;
    KeyboardEventTypes = BABYLON.KeyboardEventTypes;
    KeyboardInfo = BABYLON.KeyboardInfo;
    Nullable = BABYLON.Nullable;
    AxesViewer = BABYLON.AxesViewer;
    IAnimationKey = BABYLON.IAnimationKey;
    MorphTargetManager = BABYLON.MorphTargetManager;
    GLTF2 = BABYLON.GLTF2;
    GLTFFileLoader = BABYLON.GLTFFileLoader;
}

bindBabylonGlobals();
